import { Helmet } from 'react-helmet';
import NewdanhmucphieunhapDetail
  from 'src/components/newdanhmucphieunhap-detail/NewdanhmucphieunhapDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucphieunhapListToolbar from '../components/newdanhmucphieunhap-detail/NewdanhmucphieunhapToolbar';

const Newdanhmucphieunhap = () => (
  <>
    <Helmet>
      <title>Danh mục phiếu nhập</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucphieunhapListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucphieunhapDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucphieunhap;
